export const analyticsDataPeriods = [
    { id: 0, label: 'last_week', value: "last_week" },
    { id: 1, label: 'last_month', value: "last_month" },
    { id: 2, label: 'last_trimester', value: "last_trimester" },
    { id: 3, label: 'last_year', value: "last_year" },
]
